import { useMutation } from '@tanstack/react-query';

import { SpaceFormSchemaValues } from 'src/features/spaces/utils/formSchema';
import { Space } from 'src/features/spaces/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/space/:spaceId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    data: SpaceFormSchemaValues;
    spaceId: string;
    parkingId: string;
}
const mutationFn = ({ spaceId, parkingId, data }: DTO): Promise<Space> => {
    return axios.patch(formatResourcePath(RESOURCE, { spaceId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateSpace };
